import { render } from "./AnswerRecordManagement.vue?vue&type=template&id=5d519941&scoped=true"
import script from "./AnswerRecordManagement.vue?vue&type=script&lang=js"
export * from "./AnswerRecordManagement.vue?vue&type=script&lang=js"

import "./AnswerRecordManagement.vue?vue&type=style&index=0&id=5d519941&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d519941"]])

export default __exports__